import Image from "next/image";
import Link from "next/link";
import { useTranslation } from "next-i18next";
import { useEffect, useState, memo } from "react";

import { useGetSet } from "@api/hooks/queries/useGetSet";
import BlockTitle from "@components/cms/BlockTitle/BlockTitle";
import { getPageFolderName } from "@config/cms";
import { blurDataURL } from "@config/config";
import Container from "@ui-kit/Container/Container";
import Slider from "@ui-kit/Slider/Slider";
import SliderControls from "@ui-kit/Slider/SliderControls";
import SliderSlides from "@ui-kit/Slider/SliderSlides";

import { typeSlider } from "./datas";
import s from "./GaleryV5Block.module.scss";

const GaleryV5Block = ({ settings, data, updateField }) => {
  const { t } = useTranslation(["common"]);
  const { title, collections } = data;
  const { sliderV5 } = collections;
  const { items } = sliderV5;
  const { blockType } = settings.common;
  const [allSlides, setAllSlides] = useState([]);

  const [getSet] = useGetSet({ lazy: true });

  useEffect(() => {
    const promises = [];
    const filtered = items.filter((item) => {
      return typeof item.isShow === "boolean" ? item.isShow : true;
    });
    filtered.forEach((slide) => {
      if (slide.setId) {
        promises.push(
          getSet({
            variables: {
              id: slide.setId,
            },
          }),
        );
      }
    });

    Promise.all(promises).then((data) => {
      setAllSlides([]);
      let counter = 0;
      filtered.forEach((slide) => {
        if (slide.setId) {
          const setPages = data[counter].data.getSet.data.map((page) => {
            return {
              title: page.title,
              alt: page.seo.description,
              image: page.seo.thumbnailBig || page.seo.thumbnail,
              description: page.seo.description,
              link: `/${getPageFolderName()[slide.setType]}/${page.slug}`,
            };
          });

          setAllSlides((slides) => [...slides, ...setPages]);

          counter += 1;

          return;
        }

        setAllSlides((slides) => [...slides, slide]);
      });
    });
  }, [items]);

  return (
    <Container className={s.galeryV5}>
      <Container full={false}>
        <section>
          <BlockTitle
            settings={settings}
            field={{ title }}
            onChange={updateField}
            type={blockType}
          />
          <Slider
            // autoScroll
            collectionType={typeSlider}
            className={s.slider}
            startPadding
            slidesCount={allSlides.length}
            render={(sliderProps) => (
              <>
                <SliderSlides
                  {...sliderProps}
                  className={s.slides}
                  snapAlign="start"
                >
                  {allSlides.map((slide, key) => {
                    const { link, title, description, image, alt } = slide;
                    return (
                      <Link href={link} key={key} className={s.slide}>
                        <Image
                          className={s.img}
                          src={image}
                          fill
                          // quality={100}
                          alt={alt}
                          style={{
                            objectFit: "cover",
                            objectPosition: "center",
                          }}
                          blurDataURL={blurDataURL}
                          // sizes="(max-width: 767px) 320px, 652px"
                        />
                        <div className={s.content}>
                          <div className={s.title}>{title}</div>
                          <div className={s.description}>{description}</div>
                          <div className={s.explore}>{t("explore")}</div>
                        </div>
                      </Link>
                    );
                  })}
                </SliderSlides>
                <SliderControls className={s.controls} {...sliderProps} />
              </>
            )}
          />
        </section>
      </Container>
    </Container>
  );
};

export default memo(GaleryV5Block);
